<div class="hx-page-header__container">
  <!-- Left Section: Back button or custom content -->
  <div class="hx-page-header__left">
    <button
      hxIconButton
      variant="ghost"
      [size]="backButtonSize()"
      [context]="backButtonContext()"
      [fontIcon]="backButtonIcon()"
      [hxTooltip]="backButtonTooltip()"
      [attr.aria-label]="backButtonAriaLabel()"
      (click)="onBackClick()"
      class="hx-page-header__back-button"></button>
    @if (showBackButtonLabel()) {
      <span class="hx-page-header__back-label">{{ backButtonLabel() }}</span>
    }
    <hx-divider [vertical]="true" class="hx-page-header__divider"></hx-divider>
    <ng-content select="[hxPageHeaderLeft]" />
  </div>

  <!-- Center Section: Title or custom content -->
  <div class="hx-page-header__center">
    @if (title() || subtitle()) {
      <div class="hx-page-header__title-group">
        @if (title()) {
          <h1 class="hx-page-header__title">{{ title() }}</h1>
        }
        @if (subtitle()) {
          <p class="hx-page-header__subtitle" [innerHTML]="subtitle()"></p>
        }
      </div>
    }
    <ng-content select="[hxPageHeaderCenter]" />
  </div>

  <!-- Right Section: Custom content projection -->
  <div class="hx-page-header__right">
    <ng-content select="[hxPageHeaderRight]" />
  </div>
</div>
